import { useEffect } from 'react';
const SRC = 'use-finalcut-effects.ts';

import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { useAppNavigator, Path } from 'components/_hooks/use-router';
import { useClipPlaybackFc } from 'components/app/_mediator/clip-playback/use-clip-playback-fc';
import { useFinalcutCb } from './use-finalcut-cb';
import { setFcPlayback } from './fc-controls.slice';

export const useFinalcut = () => {
  const { navigateTo } = useAppNavigator();
  const { fcPlay, fcPause, fcIsEnded, fcReset, fcSeekTo } = useFinalcutCb();
  const fcPlayback = useAppSelector((state) => state.fc__controls.fcPlayback);
  const tracksRestored = useAppSelector((state) => state.memory.tracksRestored);
  const { dragger, storyLoaded } = useAppSelector((state) => state.app);
  const finalcuts = useAppSelector((state) => state.app__data.finalcuts);

  const dispatch = useAppDispatch();

  useClipPlaybackFc();

  useEffect(() => {
    return () => fcReset('ui');
  }, []);

  /* redirect */

  useEffect(() => {
    if (!storyLoaded || finalcuts.length !== 0) return;
    console.error(`[${SRC}] useEffect: finalcutsAvailable`);
    navigateTo(Path.storyboard);
  }, [storyLoaded, finalcuts.length]);

  /* playback */

  useEffect(() => {
    if (!tracksRestored) return;
    if (fcPlayback && !dragger) {
      if (fcIsEnded()) fcSeekTo(0);
      else fcPlay();
    } else fcPause();
  }, [fcPlayback, tracksRestored]);

  useEffect(() => {
    if (dragger || !fcPlayback) return;
    if (fcIsEnded()) dispatch(setFcPlayback(false));
    else fcPlay();
  }, [dragger]);
};
